import script from "./InputUrl.vue?vue&type=script&lang=ts"
export * from "./InputUrl.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__